import { configureStore } from '@reduxjs/toolkit';
import RootReducer from '../reducers/root-reducer';

const store = configureStore({
  reducer: RootReducer,
  devTools: process.env.NODE_ENV !== 'production', // enables Redux DevTools
  // Redux Toolkit includes `redux-thunk` by default
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
